import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import ChartCard from './ChartCard';

interface PerformanceBarChartProps {
  data: Array<{
    name: string;
    total: number;
    ativos: number;
    assinados?: number;
    valor?: number;
  }>;
  title?: string;
  subtitle?: string;
  showValue?: boolean;
}

const PerformanceBarChart: React.FC<PerformanceBarChartProps> = ({ 
  data, 
  title = 'Performance',
  subtitle,
  showValue = false
}) => {
  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          background: 'rgba(44, 62, 80, 0.95)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '8px',
          padding: '12px',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}>
          <p style={{ margin: '0 0 4px 0', fontWeight: 600 }}>{payload[0].payload.name}</p>
          {payload.map((entry: any, index: number) => (
            <p key={index} style={{ margin: '4px 0', color: entry.color }}>
              {entry.name}: {entry.value}{entry.name.includes('Valor') ? ' R$' : ''}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  return (
    <ChartCard title={title} subtitle={subtitle}>
      <ResponsiveContainer width="100%" height={350}>
        <BarChart 
          data={data} 
          margin={{ top: 5, right: 30, left: 20, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
          <XAxis 
            dataKey="name" 
            stroke="rgba(255, 255, 255, 0.6)"
            tick={{ fill: 'rgba(255, 255, 255, 0.8)', fontSize: 12 }}
            angle={-45}
            textAnchor="end"
            height={80}
          />
          <YAxis 
            stroke="rgba(255, 255, 255, 0.6)" 
            tick={{ fill: 'rgba(255, 255, 255, 0.8)' }}
            tickFormatter={showValue ? formatCurrency : undefined}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="total" fill="#3498db" name="Total Contratos" radius={[4, 4, 0, 0]} />
          <Bar dataKey="ativos" fill="#2ecc71" name="Contratos Ativos" radius={[4, 4, 0, 0]} />
          {data.some(d => d.assinados !== undefined) && (
            <Bar dataKey="assinados" fill="#9b59b6" name="Contratos Assinados" radius={[4, 4, 0, 0]} />
          )}
          {showValue && <Bar dataKey="valor" fill="#f39c12" name="Valor Mensal" radius={[4, 4, 0, 0]} />}
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
};

export default PerformanceBarChart;

